import { Card, Typography, Divider } from "antd";
import "./UnderstandingCard.scss";

const { Title, Text } = Typography;

export default function UnderstandingCard({ token }) {
  return (
    <Card
      className="aboutUnderstanding-card"
      hoverable
      style={{
        border: "none",
        backgroundColor: token?.Card?.colorBgCard,
        borderLeft: `4px solid ${token?.colorPrimary}`,
      }}>
      <div className="aboutUnderstanding-card__content">
        <Title level={3} style={{ color: token?.colorPrimary, margin: 0 }}>
          Understanding Patient Record Management
        </Title>
        <Text className="aboutUnderstanding-card__text">
          In healthcare, maintaining accurate and accessible patient records is
          crucial for delivering quality care. Our platform serves as a
          centralized hub where authorized healthcare professionals can securely
          access, update, and manage patient information.
        </Text>
        <Divider className="aboutUnderstanding-card__divider" />
        <div>
          <Title level={3} style={{ color: token?.colorPrimary, margin: 0 }}>
            How It Works
          </Title>
          <Text className="aboutUnderstanding-card__text">
            Healthcare organizations use our platform to maintain comprehensive
            patient databases. When a patient visits a facility, authorized
            staff can quickly search for and access relevant medical history,
            ensuring continuity of care and informed decision-making.
          </Text>
          <Text className="aboutUnderstanding-card__text">
            Our role-based access control ensures that only authorized personnel
            can view sensitive information, maintaining HIPAA compliance and
            patient privacy at all times.
          </Text>
        </div>
        <Divider className="aboutUnderstanding-card__divider" />
        <div>
          <Title level={3} style={{ color: token?.colorPrimary, margin: 0 }}>
            Commitment to Fairness
          </Title>
          <Text className="aboutUnderstanding-card__text">
            We believe in transparency and accountability. Our system includes
            robust audit trails, ensuring that all record access and
            modifications are tracked. This protects both patients and
            healthcare providers, creating a trustworthy ecosystem built on
            integrity and respect for privacy.
          </Text>
        </div>
      </div>
    </Card>
  );
}
